<template>
    <div>
        <mu-col class="vld-parent">
            <loading 
                :active.sync="get_loading.show" 
                :color="(get_loading.color === null) ? '#005296' : get_loading.color"
                :background-color="(get_loading.background === null) ? '#606161' : get_loading.background"
                :opacity="get_loading.opacity"
                :width="get_loading.size"
                :height="get_loading.size"
                :is-full-page="true"
                :loader="(['spinner', 'dots', 'bars'].indexOf(get_loading.type) != -1) ? get_loading.type : 'spinner'"> <!-- SET IF THERE IS NO MESSAGE -->
                <mu-col  v-if="get_loading.message != null || get_loading.html != null">
                    <mu-col class="text-center">
                        <mu-circular-progress class="text-center" :color="(get_loading.color === null) ? '#fff' : get_loading.color"  :size="get_loading.size" />
                    </mu-col>
                    <mu-col v-html="get_loading.message" :style="(get_loading.color_text === null) ? 'color:#fff' : `color:${get_loading.color_text}`" />
                </mu-col>    
            </loading>
        </mu-col>
    </div>
</template>

<script>
    // HELPERS
    import _GlobalHelper from '@/store/helpers/global'
    // VUEX
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters({
                get_loading: _GlobalHelper.getters.loading
            }),
        },
        watch: {
            get_loading(data) {
                if (data.timeout_active) {
                    this.Loading()
                }
            }
        },
        methods: {
            ...mapMutations({
                set_loading: _GlobalHelper.mutations.loading
            }),

            Loading() {
                this.set_loading({ 
                    show: false,
                    message: null,
                    color_text: null,
                    color: null,
                    background: null,
                    type: 'spinner',
                    size: 100,
                    opacity: 0.8,
                    timeout_active: false 
                })
            }
        }
    }
</script>